import type { ProductCardProps } from "@/components/product";
import { ProductCard } from "@/components/product";
import { useCareplanContext } from "@/domains/careplan/contexts/use-careplan-context";
import { Divider } from "@/ui";

export const CareplanProduct = ({ product, ref }: ProductCardProps) => {
  const careplan = useCareplanContext();

  const changes = careplan.getProductRoleChanges(product.role);

  return (
    <ProductCard.Root
      aria-label={product.name}
      className="flex scroll-mt-20 flex-col gap-6 overflow-hidden px-5 py-6 focus:outline-3 focus:outline-offset-2 focus:outline-focus focus:outline-solid sm:scroll-mt-22 sm:gap-8 sm:px-10 sm:py-10"
      key={product.id}
      product={{
        ...product,
        changes,
      }}
      ref={ref}
    >
      <div className="flex flex-col gap-3.5 sm:gap-4.5">
        {(!!product.whyRecommended || !!changes?.length) && (
          <>
            <div className="flex flex-col items-start gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
              <ProductCard.WhyRecommended />
              <ProductCard.UpdatedAt className="sm:shrink-0" />
            </div>
            <Divider.Line />
          </>
        )}
        <div className="flex flex-col gap-6 md:grid md:grid-cols-2 md:grid-rows-[auto_1fr]">
          <div className="order-1 flex flex-col gap-2 md:order-2 md:gap-3">
            <ProductCard.Rating />
            <div className="flex items-start justify-between gap-3.5 md:flex-col md:gap-6">
              <div className="flex min-w-0 flex-col gap-1 md:gap-2">
                <ProductCard.Name level={2} />
                <ProductCard.Format />
              </div>
              <div className="shrink-0 md:flex md:w-full md:items-baseline md:justify-between md:gap-4">
                <ProductCard.Price />
                <ProductCard.CartLink className="hidden md:flex" compact />
              </div>
            </div>
            <ProductCard.CartLink className="md:hidden" />
          </div>
          <ProductCard.Carousel className="order-2 row-span-2 md:order-1" />
          <ProductCard.Description className="order-3 row-span-1 md:self-start" />
        </div>
      </div>
      <ProductCard.Instructions />
      <ProductCard.DosingAndEffects />
      <ProductCard.Details />
    </ProductCard.Root>
  );
};
